export default __webpack_public_path__ + "fonts/2a546580dd8893bf84cd79208300b729.svg";